import type { ICartItemDetail } from '@/common/interfaces/cart.interface';

type StoreCartSelectionRecord = ICartItemDetail & {
  isSelected?: 0 | 1 | boolean;
  is_active?: boolean;
};

const normalizeStoreCartSelectionValue = (value: unknown): 0 | 1 | undefined => {
  if (value === 0 || value === 1) {
    return value;
  }

  if (value === '0' || value === false) {
    return 0;
  }

  if (value === '1' || value === true) {
    return 1;
  }

  return undefined;
};

/** Normalize API selection flag (`isSelected` camelCase or `is_selected` snake_case). */
export const resolveStoreCartItemSelectionFlag = (item: ICartItemDetail): 0 | 1 | undefined => {
  const record = item as StoreCartSelectionRecord;

  if (record.is_selected === 0 || record.is_selected === 1) {
    return record.is_selected;
  }

  const { isSelected } = record;
  const normalizedIsSelected = normalizeStoreCartSelectionValue(isSelected);

  if (normalizedIsSelected != null) {
    return normalizedIsSelected;
  }

  return undefined;
};

export const isStoreCartLineActive = (item: ICartItemDetail): boolean => {
  const selectionFlag = resolveStoreCartItemSelectionFlag(item);

  if (selectionFlag === 0) {
    return false;
  }

  if (selectionFlag === 1) {
    return true;
  }

  const record = item as StoreCartSelectionRecord;

  if (record.isActive === false || record.is_active === false) {
    return false;
  }

  return true;
};
